import { render, staticRenderFns } from "./tro.vue?vue&type=template&id=a1c7a5c0"
import script from "./tro.vue?vue&type=script&lang=js"
export * from "./tro.vue?vue&type=script&lang=js"
import style0 from "./tro.vue?vue&type=style&index=0&id=a1c7a5c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports